import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useOrganization } from '../../contexts/OrganizationContext';

const SandboxBanner: React.FC = () => {
  const { currentOrganization } = useOrganization();

  if (!currentOrganization?.sandbox_mode) {
    return null;
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-6 py-3">
      <div className="flex items-start space-x-3">
        <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-1">
            <span className="font-semibold text-amber-900">Mode Sandbox Activé</span>
            <span className="px-2 py-0.5 bg-amber-200 text-amber-800 text-xs font-medium rounded">
              SANDBOX
            </span>
          </div>
          <div className="text-sm text-amber-800 space-y-1">
            <p>
              Vous êtes actuellement en mode sandbox. Les fonctionnalités suivantes sont limitées :
            </p>
            <ul className="list-disc list-inside ml-2 space-y-0.5">
              <li>Aucune alerte réelle n'est déclenchée - les alertes affichées sont uniquement à des fins de démonstration</li>
              <li>Le nombre d'entités est limité à 50</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SandboxBanner;

